import React from 'react'
import { connect } from 'react-redux'
import { View } from './components'
import ViewModalLogin from '../../components/ViewModalLogin'
import Login from './login'
import { userIsLoggedIn } from '../../selectors/auth'

const LOGIN = process.env.REACT_APP_SITE_BASE_URL

class _LoginPage_ extends React.Component {
  componentWillMount() {
    const href = window.location.href.toLowerCase()
    const { userIsLoggedIn } = this.props
    if (!href.includes('localhost') && !userIsLoggedIn) {
      window.location.href = LOGIN
    }
  }

  render() {
    return (
      <View>
        <Login />
      </View>
    )
  }
}

const mapStateToProps = state => ({
  userIsLoggedIn: userIsLoggedIn(state)
})

export const LoginPage = connect(mapStateToProps)(_LoginPage_)

export const LoginModal = ({ isOpen, onClose, onLogin }) => (
  <ViewModalLogin isOpen={isOpen} onClose={onClose}>
    <Login onLogin={onLogin} />
  </ViewModalLogin>
)



// WEBPACK FOOTER //
// ./src/modules/Login/index.js